"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerTags = exports.checkTagUsed = exports.PLAYER_INTERFACE_TAGS_ORDER = void 0;
const vue_1 = require("vue");
const TagCount_1 = require("../TagCount");
const Tags_1 = require("../../cards/Tags");
const SpecialTags_1 = require("../../cards/SpecialTags");
const OverviewSettings_1 = require("./OverviewSettings");
const PlayerTagDiscount_1 = require("./PlayerTagDiscount");
const VictoryPointMultiplier_1 = require("./VictoryPointMultiplier");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const TurmoilPolicy_1 = require("../../turmoil/TurmoilPolicy");
const CardName_1 = require("../../CardName");
const Phase_1 = require("../../Phase");
const JOVIAN_MULTIPLIERS = [
    CardName_1.CardName.IO_MINING_INDUSTRIES,
    CardName_1.CardName.GANYMEDE_COLONY,
    CardName_1.CardName.WATER_IMPORT_FROM_EUROPA,
];
const MOON_MULTIPLIERS = [
    CardName_1.CardName.COPERNICUS_TOWER,
    CardName_1.CardName.LUNA_SENATE,
];
const hasDiscount = (tag, card) => {
    if (tag === SpecialTags_1.SpecialTags.COLONY_COUNT || tag === SpecialTags_1.SpecialTags.CITY_COUNT)
        return false;
    if (card.discount === undefined)
        return false;
    if (tag === 'all') {
        if (Array.isArray(card.discount)) {
            return card.discount.some((discount) => discount.tag === undefined);
        }
        else {
            return card.discount.tag === undefined;
        }
    }
    if (Array.isArray(card.discount)) {
        return card.discount.some((discount) => discount.tag === tag);
    }
    else {
        return card.discount.tag === tag;
    }
};
const getDiscountAmount = (tag, card) => {
    var _a;
    if (hasDiscount(tag, card)) {
        if (Array.isArray(card.discount)) {
            const discount = card.discount.find((d) => d.tag === tag);
            return (discount === null || discount === void 0 ? void 0 : discount.amount) || 0;
        }
        else {
            return ((_a = card.discount) === null || _a === void 0 ? void 0 : _a.amount) || 0;
        }
    }
    return 0;
};
exports.PLAYER_INTERFACE_TAGS_ORDER = [
    Tags_1.Tags.BUILDING,
    Tags_1.Tags.SPACE,
    Tags_1.Tags.SCIENCE,
    Tags_1.Tags.ENERGY,
    Tags_1.Tags.EARTH,
    Tags_1.Tags.JOVIAN,
    Tags_1.Tags.VENUS,
    Tags_1.Tags.PLANT,
    Tags_1.Tags.MICROBE,
    Tags_1.Tags.ANIMAL,
    Tags_1.Tags.CITY,
    Tags_1.Tags.MOON,
    'separator',
    Tags_1.Tags.EVENT,
    SpecialTags_1.SpecialTags.NONE,
    Tags_1.Tags.WILDCARD,
    SpecialTags_1.SpecialTags.INFLUENCE,
    SpecialTags_1.SpecialTags.CITY_COUNT,
    SpecialTags_1.SpecialTags.COLONY_COUNT,
];
const checkTagUsed = (tag, player) => {
    if (player.gameOptions.coloniesExtension === false && tag === SpecialTags_1.SpecialTags.COLONY_COUNT) {
        return false;
    }
    if (player.turmoil === undefined && tag === SpecialTags_1.SpecialTags.INFLUENCE) {
        return false;
    }
    if (player.gameOptions.venusNextExtension === false && tag === Tags_1.Tags.VENUS) {
        return false;
    }
    if (player.gameOptions.moonExpansion === false && tag === Tags_1.Tags.MOON) {
        return false;
    }
    return true;
};
exports.checkTagUsed = checkTagUsed;
exports.PlayerTags = vue_1.default.component('player-tags', {
    props: {
        player: {
            type: Object,
        },
        isActivePlayer: {
            type: Boolean,
        },
        hideZeroTags: {
            type: Boolean,
        },
    },
    components: {
        'tag-count': TagCount_1.TagCount,
        PlayerTagDiscount: PlayerTagDiscount_1.PlayerTagDiscount,
        VictoryPointMultiplier: VictoryPointMultiplier_1.VictoryPointMultiplier,
    },
    methods: {
        showColonyCount: function () {
            return this.player.gameOptions.coloniesExtension;
        },
        showInfluence: function () {
            return this.player.turmoil !== undefined;
        },
        showVenus: function () {
            return this.player.gameOptions.venusNextExtension;
        },
        showMoon: function () {
            return this.player.gameOptions.moonExpansion;
        },
        getTagsPlaceholders: function () {
            const tags = exports.PLAYER_INTERFACE_TAGS_ORDER;
            return tags.filter((tag) => {
                return exports.checkTagUsed(tag, this.player);
            });
        },
        getCardCount: function () {
            if (this.player.phase === Phase_1.Phase.RESEARCH)
                return -1;
            return this.player.cardsInHandNbr;
        },
        getTR: function () {
            return this.player.terraformRating;
        },
        getVpCount: function () {
            return this.player.victoryPointsBreakdown.total;
        },
        showShortTags: function () {
            if (this.hideZeroTags === true)
                return true;
            return OverviewSettings_1.isTagsViewConcise(this.$root);
        },
        hasTagDiscount: function (tag) {
            var _a, _b;
            for (const card of [...this.player.playedCards, ...this.player.corporationCards]) {
                if (card !== undefined) {
                    if (hasDiscount(tag, card)) {
                        return true;
                    }
                }
            }
            const turmoil = this.player.turmoil;
            const rulingParty = turmoil === null || turmoil === void 0 ? void 0 : turmoil.ruling;
            const rulingPartyPolicyId = (_a = turmoil === null || turmoil === void 0 ? void 0 : turmoil.politicalAgendas) === null || _a === void 0 ? void 0 : _a.currentAgenda.policyId;
            const dominantParty = turmoil === null || turmoil === void 0 ? void 0 : turmoil.dominant;
            const dominantPartyPolicyId = (_b = turmoil === null || turmoil === void 0 ? void 0 : turmoil.parties.find((party) => party.name === dominantParty)) === null || _b === void 0 ? void 0 : _b.rulingPolicy;
            const isMarsCoalition = this.player.corporationCards.some((corp) => corp.name === CardName_1.CardName.MARS_COALITION);
            switch (tag) {
                case Tags_1.Tags.SPACE:
                    if (rulingParty === PartyName_1.PartyName.UNITY && rulingPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_4)
                        return true;
                    if (isMarsCoalition && dominantPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_4)
                        return true;
                    break;
                case Tags_1.Tags.ENERGY:
                    if (rulingParty === PartyName_1.PartyName.EMPOWER && rulingPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_4)
                        return true;
                    if (isMarsCoalition && dominantPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_4)
                        return true;
                    break;
                case Tags_1.Tags.EVENT:
                    if (rulingParty === PartyName_1.PartyName.CENTRISTS && rulingPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_4)
                        return true;
                    if (isMarsCoalition && dominantPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_4)
                        return true;
                    break;
                case Tags_1.Tags.EARTH:
                    if (rulingParty === PartyName_1.PartyName.BUREAUCRATS && rulingPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.BUREAUCRATS_POLICY_4)
                        return true;
                    if (isMarsCoalition && dominantPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.BUREAUCRATS_POLICY_4)
                        return true;
                    break;
                default:
                    break;
            }
            if (tag === 'all' && this.player.cardDiscount > 0) {
                return true;
            }
            return false;
        },
        getTagDiscountAmount: function (tag) {
            var _a, _b;
            let discount = 0;
            for (const card of [...this.player.playedCards, ...this.player.corporationCards]) {
                if (card !== undefined) {
                    discount += getDiscountAmount(tag, card);
                }
            }
            const turmoil = this.player.turmoil;
            const rulingPartyPolicyId = (_a = turmoil === null || turmoil === void 0 ? void 0 : turmoil.politicalAgendas) === null || _a === void 0 ? void 0 : _a.currentAgenda.policyId;
            const dominantParty = turmoil === null || turmoil === void 0 ? void 0 : turmoil.dominant;
            const dominantPartyPolicyId = (_b = turmoil === null || turmoil === void 0 ? void 0 : turmoil.parties.find((party) => party.name === dominantParty)) === null || _b === void 0 ? void 0 : _b.rulingPolicy;
            const isMarsCoalition = this.player.corporationCards.some((corp) => corp.name === CardName_1.CardName.MARS_COALITION);
            switch (tag) {
                case Tags_1.Tags.SPACE:
                    if ((isMarsCoalition && dominantPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_4) || ((turmoil === null || turmoil === void 0 ? void 0 : turmoil.ruling) === PartyName_1.PartyName.UNITY && rulingPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_4)) {
                        discount += 2;
                    }
                    break;
                case Tags_1.Tags.ENERGY:
                    if ((isMarsCoalition && dominantPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_4) || ((turmoil === null || turmoil === void 0 ? void 0 : turmoil.ruling) === PartyName_1.PartyName.EMPOWER && rulingPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_4)) {
                        discount += 3;
                    }
                    break;
                case Tags_1.Tags.EVENT:
                    if ((isMarsCoalition && dominantPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_4) || ((turmoil === null || turmoil === void 0 ? void 0 : turmoil.ruling) === PartyName_1.PartyName.CENTRISTS && rulingPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_4)) {
                        discount += 2;
                    }
                    break;
                case Tags_1.Tags.EARTH:
                    if ((isMarsCoalition && dominantPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.BUREAUCRATS_POLICY_4) || ((turmoil === null || turmoil === void 0 ? void 0 : turmoil.ruling) === PartyName_1.PartyName.BUREAUCRATS && rulingPartyPolicyId === TurmoilPolicy_1.TurmoilPolicy.BUREAUCRATS_POLICY_4)) {
                        discount += 3;
                    }
                    break;
                default:
                    break;
            }
            if (tag === 'all') {
                discount += this.player.cardDiscount;
            }
            return discount;
        },
        getTagCount: function (tagName) {
            if (tagName === SpecialTags_1.SpecialTags.COLONY_COUNT && this.showColonyCount()) {
                return this.player.coloniesCount || 0;
            }
            if (tagName === SpecialTags_1.SpecialTags.INFLUENCE && this.showInfluence()) {
                return this.player.influence || 0;
            }
            if (tagName === SpecialTags_1.SpecialTags.CITY_COUNT) {
                return this.player.citiesCount || 0;
            }
            if (tagName === SpecialTags_1.SpecialTags.NONE) {
                return this.player.noTagsCount || 0;
            }
            const basicTagFound = this.player.tags.find((tag) => tag.tag === tagName);
            if (basicTagFound !== undefined) {
                return basicTagFound.count;
            }
            return 0;
        },
        showJovianMultipliers: function (tag) {
            return tag === Tags_1.Tags.JOVIAN && this.playerJovianMultipliersCount() > 0;
        },
        playerJovianMultipliersCount: function () {
            let multipliers = 0;
            for (const card of this.player.playedCards) {
                if (card !== undefined && JOVIAN_MULTIPLIERS.includes(card.name)) {
                    multipliers += 1;
                }
            }
            return multipliers;
        },
        showMoonMultipliers: function (tag) {
            return tag === Tags_1.Tags.MOON && this.playerMoonMultipliersCount() > 0;
        },
        playerMoonMultipliersCount: function () {
            let multipliers = 0;
            for (const card of this.player.playedCards) {
                if (card !== undefined && MOON_MULTIPLIERS.includes(card.name)) {
                    multipliers += 1;
                }
            }
            return multipliers;
        },
        getAvailableBlueActionCount: function () {
            return this.player.availableBlueCardActionCount;
        },
        isEscapeVelocityOn: function () {
            return this.player.gameOptions.escapeVelocityMode;
        },
        getEscapeVelocityPenalty: function () {
            return this.player.victoryPointsBreakdown.escapeVelocity;
        },
    },
    template: `
        <div class="player-tags">
            <div class="player-tags-main">
                <tag-count :tag="'vp'" :count="getVpCount()" :size="'big'" :type="'main'" />

                <div v-if="isEscapeVelocityOn()" class="tag-display tooltip tooltip-top" data-tooltip="Escape Velocity penalty">
                  <tag-count :tag="'escape'" :count="getEscapeVelocityPenalty()" :size="'big'" :type="'main'"/>
                </div>

                <tag-count :tag="'tr'" :count="getTR()" :size="'big'" :type="'main'"/>

                <div class="tag-display tooltip tooltip-top" data-tooltip="The number of available active card actions">
                    <div class="tag-count tag-action-card">
                    <div class="blue-stripe"></div>
                    <div class="red-arrow"></div>
                    </div>
                    <span class="tag-count-display">{{ getAvailableBlueActionCount() }}</span>
                </div>

                <div class="tag-and-discount">
                  <PlayerTagDiscount v-if="hasTagDiscount('all')" :amount="getTagDiscountAmount('all')" :color="player.color" />
                  <tag-count :tag="'cards'" :count="getCardCount()" :size="'big'" :type="'main'"/>
                </div>
            </div>
            <div class="player-tags-secondary">
                <template v-if="showShortTags()">
                  <div class="tag-count-container" v-for="tag in player.tags">
                    <div class="tag-and-discount" :key="tag.tag">
                      <PlayerTagDiscount v-if="hasTagDiscount(tag.tag)" :amount="getTagDiscountAmount(tag.tag)" :color="player.color" />
                      <VictoryPointMultiplier v-if="showJovianMultipliers(tag.tag)" :amount="playerJovianMultipliersCount()" />
                      <VictoryPointMultiplier v-if="showMoonMultipliers(tag.tag)" :amount="playerMoonMultipliersCount()" />
                      <tag-count :tag="tag.tag" :count="tag.count" :size="'big'" :type="'secondary'"/>
                    </div>
                  </div>
                </template>
                <template v-else>
                    <div class="tag-count-container" v-for="tagName in getTagsPlaceholders()" :key="tagName">
                      <div class="tag-and-discount" v-if="tagName !== 'separator'">
                        <PlayerTagDiscount v-if="hasTagDiscount(tagName)" :color="player.color" :amount="getTagDiscountAmount(tagName)"/>
                        <VictoryPointMultiplier v-if="showJovianMultipliers(tagName)" :amount="playerJovianMultipliersCount()" />
                        <VictoryPointMultiplier v-if="showMoonMultipliers(tagName)" :amount="playerMoonMultipliersCount()" />
                        <tag-count :tag="tagName" :count="getTagCount(tagName)" :size="'big'" :type="'secondary'"/>
                      </div>
                      <div v-else class="tag-separator"></div>
                    </div>
                </template>
            </div>
        </div>
    `,
});
//# sourceMappingURL=PlayerTags.js.map